import {
    CANONICAL_VISIBILITY,
    POST_API_VISIBILITY,
    canonicalVisibilityToPostApiVisibility,
    normalizeCanonicalVisibility,
    parseCanonicalVisibility,
} from '../constants/visibility';

export const VISIBILITY_TO_LABEL = {
    [POST_API_VISIBILITY.OWNER_ONLY]: 'Only me',
    [POST_API_VISIBILITY.FRIENDS]: 'Friends',
    [POST_API_VISIBILITY.PUBLIC]: 'Public',
    [POST_API_VISIBILITY.PRIVATE]: 'Private',
};

export const LABEL_TO_VISIBILITY = {
    'Only me': POST_API_VISIBILITY.OWNER_ONLY,
    Friends: POST_API_VISIBILITY.FRIENDS,
    Followers: POST_API_VISIBILITY.FRIENDS,
    Public: POST_API_VISIBILITY.PUBLIC,
    Private: POST_API_VISIBILITY.PRIVATE,
};

const STANDARD_UI_LABEL_BY_CANONICAL_VISIBILITY = Object.freeze({
    [CANONICAL_VISIBILITY.PUBLIC]: 'Public',
    [CANONICAL_VISIBILITY.FRIENDS]: 'Friends',
    [CANONICAL_VISIBILITY.OWNER_ONLY]: 'Only me',
    [CANONICAL_VISIBILITY.PRIVATE]: 'Private',
});

const BAND_POST_UI_LABEL_BY_CANONICAL_VISIBILITY = Object.freeze({
    [CANONICAL_VISIBILITY.PUBLIC]: 'Public',
    [CANONICAL_VISIBILITY.FRIENDS]: 'Followers',
    [CANONICAL_VISIBILITY.OWNER_ONLY]: 'Private',
    [CANONICAL_VISIBILITY.PRIVATE]: 'Private',
});

export const toUiVisibility = (value, options = {}) => {
    const bandPost = options.bandPost === true;
    const canonical = normalizeCanonicalVisibility(value, CANONICAL_VISIBILITY.OWNER_ONLY);
    const labels = bandPost
        ? BAND_POST_UI_LABEL_BY_CANONICAL_VISIBILITY
        : STANDARD_UI_LABEL_BY_CANONICAL_VISIBILITY;
    return labels[canonical] || (bandPost ? 'Private' : 'Only me');
};

export const toBandPostUiVisibility = (value) => toUiVisibility(value, { bandPost: true });

const resolveVisibilityValue = (value) => {
    const canonical = parseCanonicalVisibility(value);
    return canonical ? canonicalVisibilityToPostApiVisibility(canonical) : null;
};

export const toApiVisibility = (value) => {
    const normalized = resolveVisibilityValue(value);
    if (!normalized) {
        const error = new Error('Unknown visibility selection. Please choose Public, Friends, Followers, Only me, or Private.');
        error.code = 'INVALID_VISIBILITY';
        throw error;
    }
    return normalized;
};
